import { useMemo } from 'react';

import { useIsSegmentationAdminEnabled } from '../../featureChecks';
import type { UseMainUIFeatureSettings } from '../../types';
import { uiFeatureAccessSymbol } from '../../types';

export const useSegmentationSettingsAdminPageSettings: UseMainUIFeatureSettings<'segmentationAdminPage'> = (
  options
) => {
  const segmentationAdminSettingsPageSettingsOverrides = options?.overrides?.segmentationAdminPage;

  const segmentationSettingsPageSettingsPolicy = useIsSegmentationAdminEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: segmentationSettingsPageSettingsPolicy,
      ...segmentationAdminSettingsPageSettingsOverrides,
    }),
    [segmentationAdminSettingsPageSettingsOverrides, segmentationSettingsPageSettingsPolicy]
  );
};
